export default __webpack_public_path__ + "static/media/cluster.81072bd6.svg";